// extracted by mini-css-extract-plugin
export default {"card":"DepositWidget__card--ig-_s39_"};